import React from 'react'
import {RenderRoutes} from './routes'
import routes from './routes/config'
import 'antd/dist/antd.css'
import {DataProvider} from './data'
import Gordita from './fonts/GorditaRegular.woff2'
import {createMuiTheme, ThemeProvider, CssBaseline} from '@material-ui/core'
import './App.css';

const gordita = {
	fontFamily: 'Gordita',
	fontStyle: 'normal',
	fontDisplay: 'swap',
	fontWeight: 400,
	src: `
		local('GorditaMedium'),
		local('GorditaRegular'),
		url(${Gordita}) format('woff2')
	`,
	unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
}

const theme = createMuiTheme({
	typography: {
		fontFamily: 'Gordita, Arial'
	},
	overrides: {
		MuiCssBaseline: {
			'@global': {
				'@font-face': [gordita]
			}
		}
	}

})

function App(){
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<DataProvider>
				<RenderRoutes routes={routes} />
			</DataProvider>
		</ThemeProvider>
	)
}

export default App
